import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import AddressListPage from './AddressListPage';

export const prefix = 'bm-p-address-list';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: AddressListPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
